import headers from "app/requests/headers";
import queryString from "app/requests/query-string";

export const copy = (id) => (
  fetch(`/api/admin/episodes/${id}/copy`, {
    headers: headers(),
    method: "POST"
  }).then((response) => response.json())
);

export const create = (params) => (
  fetch("/api/admin/episodes", {
    body: JSON.stringify(params),
    headers: headers(),
    method: "POST"
  }).then((response) => response.json())
);

export const destroy = (id) => (
  fetch(`/api/admin/episodes/${id}`, {
    headers: headers(),
    method: "DELETE"
  }).then((response) => response.json())
);

export const get = (id) => (
  fetch(`/api/admin/episodes/${id}`, {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);

export const getAll = (params) => (
  fetch(`/api/admin/episodes?${queryString(params || {})}`, {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);

export const update = (id, params) => (
  fetch(`/api/admin/episodes/${id}`, {
    body: JSON.stringify(params),
    headers: headers(),
    method: "PUT"
  }).then((response) => response.json())
);
